import BaseComponent from "../../../../baseComponent.js";

export default class Example extends BaseComponent {
  render() {
    var spans = [];
    var key = 0;
    var argIndex = this.props.argIndex > this.props.function.params.length - 1 ?
    this.props.function.params.length - 1 : this.props.argIndex;

    spans.push(<span key={key++}>{this.props.function.name}</span>);
    spans.push(<span className="fnp" key={key++}>(</span>);
    for (var i = 0; i < this.props.function.example.length; i++) {
      var className = "";
      if (i === argIndex) className = "arg-active";

      if (i != 0) spans.push(<span className="fnc" key={key++}>,</span>);
      spans.push(<span key={key++} className={className}>{this.props.function.example[i]}</span>);
    }
    spans.push(<span className="fnp" key={key}>)</span>);

    return (
      <div className="function-detail__example">
        <div className="function-detail__text-header">Example</div>
        <div className="function-example">
          {spans}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/functions/detail/example.jsx